import React, { useContext } from 'react';
import { Grid } from '@material-ui/core';
import CreditCard from '@material-ui/icons/CreditCard';
import { Panel } from '@michelin/acid-components';
import { useTranslation } from '@michelin/central-provider';
import LocationInformation from 'components/LocationInformation';
import { PrintContext } from 'components/PrintContext';
import { VehicleInformation } from 'components/SelectVehicle/VehicleInformation';
import moment from 'moment';
import PrintProvider, { Print } from 'react-easy-print';
import { getCommonOrderPricesParams } from 'utils/getPricesCallCommonParams';
import PartsAndServices from './PartsAndServices/PartsAndServices';

export const PrintOrderPartList = () => {
  const { t } = useTranslation();
  const { order, isDealer } = useContext(PrintContext);

  if (!order || order.parts.length === 0) return null;

  return (
    <>
      <PrintProvider>
        <Print printOnly single name="printPartList">
          <div
            id="print-content"
            style={{
              position: 'relative',
              left: '2rem',
              width: '85%',
              display: 'block',
            }}
          >
            <h2 style={{ marginBottom: 0, marginTop: 0 }}>{t('Order Sheet')}</h2>
            <div style={{ marginBottom: '2rem' }}>
              {t('Order #: {{id}}', {id: order.id})}
              <br />
              {t('Order status: {{status}}', {status: order.status.primary})}
              <br />
              {order.po_number && (
                <>
                  {t('PO #: {{poNumber}}', { poNumber: order.po_number })}
                  <br />
                </>
              )}
              {order.authorization_number && (
                <>
                  {t('Authorization #: {{authorizationNumber}}', { authorizationNumber: order.authorization_number })}
                  <br />
                </>
              )}
              {order.claim_number && (
                <>
                  {/* eslint-disable-next-line @typescript-eslint/naming-convention */}
                  {t('Delivery Receipt #: {{claim_number}}', { claim_number: order.claim_number })}
                  <br />
                </>
              )}
            </div>
            <Grid container spacing={2}>
              <Grid item xs={6}>
                <Panel
                  title={t('Fleet')}
                  variant="disabled"
                  style={{ height: '100%', borderColor: 'black', borderStyle: 'solid' }}
                >
                  <LocationInformation
                    location={order.orderer_location_core}
                    printMode
                    mobileAddress={order.mobile_address || undefined}
                  />
                </Panel>
              </Grid>
              <Grid item xs={6} spacing={2} style={{ display: 'grid', gap: 16 }}>
                <Panel title={t('Vehicle')} variant="disabled" style={{ borderColor: 'black', borderStyle: 'solid' }}>
                  {order.vehicle.id ? <VehicleInformation vehicle={order.vehicle} /> : t('Mounted Wheel Order')}
                </Panel>
                {order.credit_card_token && order.credit_card_last_four && (
                  <Panel
                    title={t('Credit Card Information')}
                    variant="disabled"
                    style={{ borderColor: 'black', borderStyle: 'solid' }}
                  >
                    <CreditCard
                      style={{
                        marginRight: 10,
                        marginBottom: -12,
                        width: 35,
                        height: 35,
                      }}
                    />
                    {order.credit_card_last_four.toString()[0]}
                    ●●● ●●●● ●●●●
                    {order.credit_card_last_four.toString().slice(1)}
                  </Panel>
                )}
              </Grid>
              <Grid item xs={order.appointment ? 6 : 12}>
                <Panel
                  title={t('Provider')}
                  variant="disabled"
                  style={{ height: '100%', borderColor: 'black', borderStyle: 'solid' }}
                >
                  <LocationInformation location={order.provider_location_core} printMode />
                </Panel>
              </Grid>
              {order.appointment && (
                <Grid item xs={6}>
                  <Panel
                    title={t('Appointment')}
                    variant="disabled"
                    style={{ height: '100%', borderColor: 'black', borderStyle: 'solid' }}
                  >
                    {t('Date: ')}
                    <b>{t(`${moment(order.appointment).format('MMMM D, YYYY').toString()}`)}</b>
                    <br />
                    {t('Time: ')}
                    <b>{t(`${moment(order.appointment).format('h:mm a').toString()}`)}</b>
                  </Panel>
                </Grid>
              )}
              <Grid item xs={12}>
                <Panel
                  title={t('Parts')}
                  variant="disabled"
                  style={{
                    borderColor: 'black',
                    borderStyle: 'solid',
                  }}
                >
                  {order?.parts?.length && (
                    <Grid container item xs={12} spacing={2}>
                      <Grid item xs={12} style={{ paddingRight: 10 }}>
                        <PartsAndServices
                          order={order}
                          printMode
                          commonPricesParams={getCommonOrderPricesParams(order, isDealer)}
                          componentPlacement="PrintLayout"
                        />
                      </Grid>
                      <hr style={{ width: '100%' }} />
                    </Grid>
                  )}
                </Panel>
              </Grid>
            </Grid>
          </div>
        </Print>
      </PrintProvider>
    </>
  );
};
